import React from 'react';
export default function Mas() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0C5.33333 0 0 5.33333 0 12C0 18.6667 5.33333 24 12 24C18.6667 24 24 18.6667 24 12C24 5.33333 18.6667 0 12 0ZM18.6667 13.3333H13.3333V18.6667H10.6667V13.3333H5.33333V10.6667H10.6667V5.33333H13.3333V10.6667H18.6667V13.3333Z" fill="#1C4183"/>
        </svg>
        );
    }